/* tslint:disable */
/* eslint-disable */

/**
 * 0 = Eau
 * 1 = Electricite
 * 2 = Gaz
 * 3 = Mazout
 * 4 = Compacteur
 */
export enum TypeReleveCompteur {
  Eau = 0,
  Electricite = 1,
  Gaz = 2,
  Mazout = 3,
  Compacteur = 4
}
